const SearchBoxComponent = ({
    dropdownRef,
    value,
    setValue,
    showDropdown,
    setShowDropdown,
    handleKeyUp,
    isSearchLoading,
    productsSuggetion,
    activitiesSuggetion,
    destinationSuggetions,
    blogsSuggetion,
    suggetionHistory,
    onClickHistoryOption,
    onClickDestination,
    onClickActivity,
    onClickProduct,
    onClickBlog,
    slugField,
}) => {
    return (
        <div className="searchBox" ref={dropdownRef}>
            <input
                className="main"
                type="text"
                placeholder="Find places and activities to do"
                onChange={(e) => {
                    setValue(e.target.value);
                    setShowDropdown(e.target.value?.trim()?.length >= 3);
                }}
                value={value}
                onKeyUp={handleKeyUp}
                // onFocus={() => setShowDropdown(true)}
                onFocus={(e) => {
                    handleKeyUp(e)
                    e.stopPropagation();
                    if (suggetionHistory?.length > 0) {
                        setShowDropdown(true);
                    }
                }}

            />

            <div className={`search-key ${!showDropdown ? "d-none" : ""}`}>
                {isSearchLoading && (
                    <div className="preloader" style={{ position: "absolute" }}>
                        <div className="preloader-icon"></div>
                    </div>
                )}

                {value?.trim().length >= 3 && !isSearchLoading &&
                    productsSuggetion.length === 0 &&
                    activitiesSuggetion.length === 0 &&
                    destinationSuggetions.length === 0 &&
                    blogsSuggetion.length === 0 && (
                        <ul>
                            <li><span>No results found</span></li>
                        </ul>
                    )}

                {isSearchLoading && (
                    <ul><li><span>Searching...</span></li></ul>
                )}

                {suggetionHistory?.length > 0 && !isSearchLoading &&
                    productsSuggetion.length === 0 &&
                    blogsSuggetion.length === 0 &&
                    activitiesSuggetion.length === 0 &&
                    destinationSuggetions.length === 0 &&
                    (value == null || value?.trim()?.length < 3) && (
                        <ul>
                            <h6><i className="fa-solid fa-magnifying-glass"></i> Recent searches</h6>
                            {suggetionHistory.map((his, index) => (
                                <li key={index} className='suggetionRecord'>
                                    <a href="javascript:void(0)" onClick={() => onClickHistoryOption(his?.url)}>
                                        {his.label}
                                        {his?.sublabel && <span>{his?.sublabel}</span>}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}

                {destinationSuggetions.length > 0 && (
                    <ul>
                        <h6><i className="fa-solid fa-location-dot"></i>Destinations</h6>
                        {destinationSuggetions.map((destination, index) => (
                            <li key={index}>
                                <a href="javascript:void(0)" onClick={() => onClickDestination(destination?.name, destination?.parent_name, destination?.[slugField])}>
                                    {destination.name}
                                    {destination?.parent_name && <span>{destination?.parent_name}</span>}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}

                <ul>
                    {(productsSuggetion.length > 0 || activitiesSuggetion.length > 0) && (
                        <h6><i className="fa-solid fa-bolt"></i>Аctivities</h6>
                    )}

                    {activitiesSuggetion.map((activity, index) => (
                        <li key={index}>
                            <a href="javascript:void(0)" onClick={() => onClickActivity(activity.id, activity.name, activity?.[slugField])}>
                                {activity.name}
                            </a>
                        </li>
                    ))}

                    {productsSuggetion.map((product, index) => {
                        const productLocation = product?.location ? JSON.parse(product.location) : null;
                        const spacedValues = productLocation ? Object.values(productLocation).join(', ') : '';
                        return (
                            <li key={index}>
                                <a href="javascript:void(0)" onClick={() => onClickProduct(product.title, spacedValues, product?.[slugField])}>
                                    {product.title}
                                    {product?.location && <span>{spacedValues}</span>}
                                </a>
                            </li>
                        );
                    })}
                </ul>

                {blogsSuggetion.length > 0 && (
                    <ul>
                        <h6 className="search-title"><i className="fa-solid fa-newspaper"></i>Blogs</h6>
                        {blogsSuggetion.map((blog, index) => (
                            <li key={index} className='suggetionRecord'>
                                <a href="javascript:void(0)" onClick={() => onClickBlog(blog.name, blog?.[slugField])}>
                                    {blog.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <i className="fa-solid fa-location-dot"></i>
        </div>
    );
};

export default SearchBoxComponent;
